<template>
<div>
    <div class="d-flex mt-3">
        <div class="col-md-4">
            <label class="label-search">*Obra:</label>
            <autocomplete-z ref="obraRHTypeahead"
                placeholder="Digite o nome da Obra"
                type="text"
                iconClass="fas fa-hard-hat"
                :serializer="(obra) => obra.referencia + ' - ' + obra.localizacao"
                :debounceLength="1"
                :formField="form.obraId"
                v-on:search="onSearchObra"
                v-on:changeCode="onChangeCodeObra"/>
        </div>
        <div class="col-md-4">
            <label class="label-search">*Responsável (Coordenador Obra)</label>
            <div class="d-flex">
                        <autocomplete-z ref="responsavelTypeaheads"
                        iconClass="fas fa-users"
                        placeholder="Digite o código do Responsável"
                        :showAllResults="true"
                        :serializer="(responsavels) => responsavels.codigo + ' - ' + responsavels.nome"
                        debounceLength="1"
                        :ShowCode="false"
                        :formField="BuscaCodigo"
                        v-on:search="onSearchResponsavelCode" />
                        <autocomplete-z ref="responsavelTypeahead"
                        placeholder="Digite o nome do Responsável"
                        :showAllResults="true"
                        :serializer="(responsavels) => responsavels.codigo + ' - ' + responsavels.nome"
                        debounceLength="4"
                        :ShowCode="false"
                        :disabled="codigoResponsavel"
                        :formField="BuscaNome"
                        v-on:search="onSearchResponsavel" />
            </div>

        </div>
        <div class="col-md-4">
            <label class="label-search">*Regional:</label>
           <div class="d-flex">
             <b-form-input type="text"
                class="col-2 text-upper"
                style="height: calc(2.09375rem + 2px);border-right: 0px;"
                :placeholder="'Código'"
                :size="form.secaoRH.maxlength"
                :state="form.secaoRH.state"
                v-on:change="onClearSection"/>
                <select v-model="form.regionalId.value" class="form-control">
                  <option :value="null">Selecione</option>
                  <option v-for="data in dataRegional" :key="data.id" :value="data.id">{{data.codigo + ' - ' + data.nome}}</option>
                </select>
           </div>
        </div>
    </div>
    <div class="d-flex mt-3">
        <div class="col-md-3">
            <label class="label-search">*Funcionário (Que recebe o crédito):</label>
            <div class="d-flex">
                        <autocomplete-z ref="favorecidoTypeaheads"
                        iconClass="fas fa-users"
                        placeholder="Digite o código do funcionário"
                        :showAllResults="true"
                        :serializer="(responsavels) => responsavels.codigo + ' - ' + responsavels.nome"
                        debounceLength="1"
                        v-on:hit="onSetPosition"
                        v-on:return="onSetPosition"
                        :ShowCode="false"
                         :disabled="nomeFavorecido"
                        :formField="FavorecidoCodigo"
                        v-on:search="onSearchFavorecidoCode" />
                        <autocomplete-z ref="favorecidoTypeahead"
                        placeholder="Digite o nome do funcionário"
                        :showAllResults="true"
                        :serializer="(responsavels) => responsavels.codigo + ' - ' + responsavels.nome"
                        debounceLength="4"
                        v-on:return="onSetPosition"
                         v-on:hit="onSetPosition"
                        :ShowCode="false"
                        :disabled="codigoFavorecido"
                        :formField="FavorecidoNome"
                        v-on:search="onSearchFavorecido" />
            </div>
        </div>
        <div class="col-md-2">
            <label class="label-search">*Funcionário (Função):</label>
                <b-form-input type="text"
                placeholder="Função do funcionário"
                v-model="form.funcionariofuncao.value"
                :maxlength="form.funcionariofuncao.maxlength"
                :required="form.funcionariofuncao.required"
                :state="form.funcionariofuncao.state"
                :disabled="true"></b-form-input>
        </div>
        <div class="col-md-2">
            <label class="label-search">*Estado Civil:</label>
                <b-form-input type="text"
                placeholder="Estado Civil"
                v-model="form.funcionarioEstadoCivi.value"
                :maxlength="form.funcionariofuncao.maxlength"
                :required="form.funcionariofuncao.required"
                :state="form.funcionariofuncao.state"
                :disabled="true"></b-form-input>
        </div>
        <div class="col-md-2">
            <label class="label-search">*Motivo Viagem:</label>
            <b-form-select v-model="form.motivoViagemId.value">
                <template slot="first">
                    <option :value="null">Selecione</option>
                    <option v-for="data in dataTravel" :key="data.id" :value="data.id">{{data.nome}}</option>
                </template>
            </b-form-select>
        </div>
        <div class="col-md-1">
            <label class="label-search">*Viagem Aérea?:</label>
            <b-form-checkbox v-model="form.passagem.value" class="switch-cus" switch size="lg"></b-form-checkbox>
        </div>
        <div class="col-md-2">
            <label class="label-search">*não irá realizar adiantamento?:</label>
            <b-form-checkbox  @input="handleCheckboxInput" id="meucheckbox" :disabled="disabledSenAdiantamento"  v-model="form.semAdiantamento.value" class="switch-cus" switch size="lg"></b-form-checkbox>
        </div>
    </div>
    <div class="d-flex mt-3">
        <div class="col-md-4">
            <label class="label-search">País / Estado / Cidade Origem:</label>
            <div class="d-flex">
                <b-form-select v-model="form.paisOrigemID.value" class="mb-3" style="max-width: 180px;margin-right: 2px" @change="onChangeCountryEnd">
                    <template slot="first" v-if="dataCountry.length >= 2">
                    <option :value="null" >Selecione</option>
                    <option  v-for="data in dataCountry" :key="data.id" :value="data.id">{{data.nome}}</option>
                    </template>

                    <template slot="first" v-else>
                    <option  :value="null">BRASIL</option>
                    </template>
                </b-form-select>
                <b-form-select v-model="form.estadoOrigemID.value"  class="mb-3" style="max-width: 180px;margin-right: 2px" @change="onChangeStateEnd">
                    <template slot="first">
                    <option :value="null">Selecione</option>
                    </template>
                    <option v-for="data in dataState" :key="data.id" :value="data.id">{{data.nome}}</option>
                </b-form-select>
                <b-form-select v-model="form.cidadeOrigemId.value"  class="mb-3" style="max-width: 180px;margin-right: 2px" >
                    <template slot="first">
                    <option :value="null">Selecione</option>
                    </template>
                    <option v-for="data in dataCity" :key="data.id" :value="data.id">{{data.nome}}</option>
                </b-form-select>
            </div>
        </div>
        <div class="col-md-4">
            <label class="label-search">País / Estado / Cidade Destino:</label>
            <div class="d-flex">
                <b-form-select v-model="form.paisDestinoID.value" class="mb-3" style="max-width: 180px;margin-right: 2px" @change="onChangeCountryFim">
                    <template slot="first" v-if="dataCountry.length >= 2">
                    <option :value="null">Selecione</option>
                    <option v-for="data in dataCountry" :key="data.id" :value="data.id">{{data.nome}}</option>
                    </template>

                    <template slot="first" v-else>
                     <option  :value="null">BRASIL</option>
                    </template>

                </b-form-select>
                <b-form-select v-model="form.estadoDestinoID.value" class="mb-3" style="max-width: 180px;margin-right: 2px" @change="onChangeStateFim">
                    <template slot="first">
                    <option :value="null">Selecione</option>
                    </template>
                    <option v-for="data in dataStateFim" :key="data.id" :value="data.id">{{data.nome}}</option>
                </b-form-select>
                <b-form-select v-model="form.cidadeDestinoId.value" class="mb-3" style="max-width: 180px;margin-right: 2px">
                    <template slot="first">
                    <option :value="null">Selecione</option>
                    </template>
                    <option v-for="data in dataCityFim" :key="data.id" :value="data.id">{{data.nome}}</option>
                </b-form-select>
            </div>
        </div>
        <div class="col-md-2">
            <label class="label-search">Início Viagem:</label>
            <datepicker name="txtDateStart"
                v-model="form.dataInicio.value"
                @input="onSelectDate($event, 'startDate')"
                :format="'dd/MM/yyyy'"
                :language="ptBR"
                :placeholder="$lang.Common.DatePlaceholder"
                :clear-button="true"
                :clear-button-icon="'fa fa-close'"
                :calendar-button="true"
                :calendar-button-icon="'fa fa-calendar'"
                :bootstrap-styling="true"
                :full-month-name="true"
                :initialView="'day'"
                :use-utc="true"/>
        </div>
        <div class="col-md-2">
            <label class="label-search">Fim Viagem:</label>
            <datepicker name="txtDateStart"
                v-model="form.dataFim.value"
                @input="onSelectDate($event, 'startDate')"
                :format="'dd/MM/yyyy'"
                :language="ptBR"
                :placeholder="$lang.Common.DatePlaceholder"
                :clear-button="true"
                :clear-button-icon="'fa fa-close'"
                :calendar-button="true"
                :calendar-button-icon="'fa fa-calendar'"
                :bootstrap-styling="true"
                :full-month-name="true"
                :initialView="'day'"
                :use-utc="true"/>
        </div>
    </div>
</div>
</template>

<script>
import InfoModalTravel from './InfoModalTravel'
export default InfoModalTravel
</script>

<style scoped>
 .label-search{
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
  }
.flex{
display: flex;
justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/InfoModalTravel/InfoModalTravel.vue